// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"316":"67624589","481":"90da6047","488":"b95bfcba","499":"ab6be147","923":"0007efc1"}[chunkId] + ".chunk.js";
};